import { render } from "./WishlistPage.vue?vue&type=template&id=9d9076f8&ts=true"
import script from "./WishlistPage.vue?vue&type=script&lang=ts"
export * from "./WishlistPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__